import { axios } from "../CommonActions";
import { toast } from "react-toastify";
import Api from "../../Constants/Api";

export const getSoftPosOtp = (data) => {
  return new Promise((resolve, reject) => {
    axios({ method: "POST", url: "softpos/otp", data })
      .then((response) => {
        resolve(response.data?.data);
        toast(response.data?.message, { type: "success" });
      })
      .catch((err) => {
        reject(err);
        toast(err?.response?.data?.message, { type: "error" });
      });
  });
};
export const getBusinessDetails = (business_id) => {
  return new Promise((resolve, reject) => {
    axios({ method: "GET", url: `softpos/business/${business_id}/details` })
      .then((response) => {
        resolve(response.data?.data);
      })
      .catch((err) => {
        reject(err);
        toast(err?.response?.data?.message, { type: "error" });
      });
  });
};

export const softPosInit = (data) => {
  return new Promise((resolve, reject) => {
    axios({ method: "POST", url: "softpos/transaction/init", data })
      .then((response) => {
        resolve(response.data?.data);
        toast(response.data?.message, { type: "success" });
      })
      .catch((err) => {
        reject(err);
        toast(err?.response?.data?.message, { type: "error" });
      });
  });
};

export function getSoftposPaymentOptions(cardNo, transaction_id) {
  return new Promise(function (resolve, reject) {
    axios({
      method: "GET",
      url: "/softpos/wallets/options",
      params: {
        card_no: cardNo,
        transaction_id,
      },
    })
      .then((res) => {
        const data = res?.data?.data;
        // put an id to all objects for deleting and pushing into array (selectedPaymentOptions in paymentData)
        for (let i = 0; i < data.length; i++) {
          data[i].id = i + 1;
        }
        let newData = data;
        newData = newData.filter((item) => item.has_payment_reward === 1);
        const response = {
          paymentOptions: data,
          selectedPaymentOptions: newData,
        };
        resolve(response);
      })
      .catch((e) => {
        reject(false);
      });
  });
}

export function softPosPaymentWithTransactionId(params) {
  return new Promise(function (resolve, reject) {
    const data = {
      transaction_id: params.transaction_id,
      club_id: params.club_id,
      type: "gateway",
      otp_code: params.otp_code,
    };
    if (params.hasOwnProperty("amount")) {
      Object.assign(data, { amount: params.amount });
    }
    if (params.hasOwnProperty("payment_using_wallet_balance")) {
      Object.assign(data, {
        payment_using_wallet_balance: params.payment_using_wallet_balance,
      });
    }
    if (
      params.hasOwnProperty("ewallets") &&
      Array.isArray(params.ewallets) &&
      params.ewallets.length > 0
    ) {
      Object.assign(data, { ewallets: JSON.stringify(params.ewallets) });
    }
    axios({
      method: "POST",
      baseURL: Api.PUBLIC_API,
      url: "softpos/payment",
      data: data,
    })
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.status &&
          Math.floor(parseInt(res.data.status) / 100) !== 2
        ) {
          const data = {
            status: "failed",
            title: "پرداخت ناموفق",
            body: res?.data?.message,
          };
          reject(data);
        } else {
          if (
            res.data.data.hasOwnProperty("redirect_url") &&
            res.data.data.redirect_url.length > 0
          ) {
            const link = res.data.data.redirect_url;
            window.open(link);
          } else {
            const data = {
              title: "پرداخت با موفقیت انجام شد",
              body: "",
              status: "success",
              transactionId: res.data.data.transaction_id,
            };
            resolve(data);
          }
        }
      })
      .catch((err) => {
        const data = {
          status: "failed",
          title: "پرداخت ناموفق",
          body: err?.response?.data?.message,
        };
        reject(data);
      });
  });
}

export function getSoftPosTransactionResult(transactionId) {
  return new Promise(function (resolve, reject) {
    if (!transactionId) {
      reject("business id needed");
    }
    axios({
      url: "club/transaction/softpos/gateway/details/" + transactionId,
      method: "GET",
    })
      .then((res) => {
        if (res.data.hasOwnProperty("data")) {
          return resolve(res?.data?.data[0]);
        }
        reject(false);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}
